import { Component } from '@angular/core';

@Component({
  selector: 'app-convert-excel-to-pdf',
  imports: [],
  templateUrl: './convert-excel-to-pdf.component.html',
  styleUrl: './convert-excel-to-pdf.component.css'
})
export class ConvertExcelToPdfComponent {

}
